import { Box, BoxProps, keyframes, useColorModeValue, usePrefersReducedMotion } from "@chakra-ui/react";

const borderGrow = keyframes`
  from { border-width: 10px; }
  to { border-width: 20px; }
`;

const BOX_COUNT = 400;
const COLOR_COUNT = 9;

const BOX_CONFIGS = Array.from({ length: BOX_COUNT }, () => ({
  bg: Math.floor(Math.random() * COLOR_COUNT),
  delay: Math.floor(Math.random() * COLOR_COUNT),
  k0: Math.floor(Math.random() * COLOR_COUNT),
  k50: Math.floor(Math.random() * COLOR_COUNT),
  k100: Math.floor(Math.random() * COLOR_COUNT),
}));

type Props = {
  bgImage: string;
  bgSize?: BoxProps["bgSize"];
  bgPos?: BoxProps["bgPos"];
  transform?: string;
};

function AnimatedBackground({ bgImage, bgSize = "cover", bgPos = "center", transform }: Props) {
  const herobgColor = useColorModeValue("white", "base.700");
  const prefersReducedMotion = usePrefersReducedMotion();
  const boxColors = [
    "--chakra-colors-base-300a",
    useColorModeValue("--chakra-colors-white", "--chakra-colors-base-700"),
    "--chakra-colors-primary-200a",
    "--chakra-colors-transparent",
    "--chakra-colors-whiteAlpha-200",
    "--chakra-colors-primary-400a",
    "--chakra-colors-secondary-200a",
    "--chakra-colors-whiteAlpha-300",
    "--chakra-colors-secondary-300a",
  ];

  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(auto-fill, minmax(120px, 1fr))"
      gridTemplateRows="repeat(auto-fill, minmax(120px, 1fr))"
      bgImage={bgImage}
      bgSize={bgSize}
      bgPos={bgPos}
      transform={transform}
      w="100%"
      position="relative"
      h="110%"
      overflow="hidden"
      alignContent="flex-start"
      borderRadius="md"
    >
      {BOX_CONFIGS.map(({ bg: bgIdx, delay, k0, k50, k100 }, ind) => {
        const colorShift = keyframes`
          0%   { background-color: var(${boxColors[k0]}); }
          50%  { background-color: var(${boxColors[k50]}); }
          100% { background-color: var(${boxColors[k100]}); }
        `;
        return (
          <Box
            // eslint-disable-next-line react/no-array-index-key
            key={ind}
            bg={prefersReducedMotion ? `var(${boxColors[bgIdx]})` : "transparent"}
            border="10px solid"
            borderWidth={["4px", null, null, "10px"]}
            animation={
              prefersReducedMotion
                ? undefined
                : `2s ease-in-out ${delay}s 1 forwards ${colorShift}, ${borderGrow} 1s ease-in-out alternate 2`
            }
            borderColor={herobgColor}
          />
        );
      })}
    </Box>
  );
}

export default AnimatedBackground;
